const nextStepStatus = [
    { key: "OPEN", value: "OPEN" },
    { key: "CLOSED", value: "CLOSED" }
];

export { nextStepStatus };